import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Instagram, Facebook, Send } from "lucide-react";
import logoUrl from "@/assets/allen-travels-logo.png";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[hsl(var(--hero-bg))] text-[hsl(var(--hero-foreground))] mt-24">
      <div
        className="absolute inset-x-0 -top-px h-px"
        style={{ background: "linear-gradient(90deg, transparent, hsl(var(--primary-glow) / 0.6), transparent)" }}
      />
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="bg-white/95 rounded-xl p-2">
                <img src={logoUrl} alt="Allen Travels RD" className="h-10 w-auto" />
              </div>
              <div className="font-display text-lg font-semibold leading-tight">
                Allen Travels
                <div className="text-[10px] uppercase tracking-[0.3em] opacity-70">RD</div>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed max-w-xs">
              Premium private transfers and curated tours across the Dominican Republic. Crafted for travelers who value comfort and detail.
            </p>
            <div className="flex gap-3 pt-2">
              {[Instagram, Facebook, Send].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 rounded-full bg-white/8 hover:bg-primary hover:scale-110 transition-smooth flex items-center justify-center"
                  aria-label="Social link"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-base font-semibold mb-4 text-white">Explore</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              {[
                ["Tours", "/tours"],
                ["Transfers", "/transfers"],
                ["Destinations", "/destinations"],
                ["Fleet", "/fleet"],
              ].map(([label, href]) => (
                <li key={href}>
                  <Link to={href} className="hover:text-primary-glow transition-smooth">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-base font-semibold mb-4 text-white">Company</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              {[
                ["About", "/about"],
                ["Contact", "/contact"],
                ["Privacy", "/privacy"],
                ["Terms", "/terms"],
              ].map(([label, href]) => (
                <li key={href}>
                  <Link to={href} className="hover:text-primary-glow transition-smooth">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-base font-semibold mb-4 text-white">Get in touch</h4>
            <ul className="space-y-3 text-sm text-white/75">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-primary-glow shrink-0" />
                Punta Cana, Dominican Republic
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-primary-glow shrink-0" />
                +1 809 555 0100
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-primary-glow shrink-0" />
                hello@allentravelsrd.com
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {year} Allen Travels RD. All rights reserved.</span>
          <span>Crafted with care in the Dominican Republic.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
